import axios from '@/axios'

// grades

export async function listGrades (educationStageId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/education-stages/' + educationStageId + '/grades')
  return response.data.data
}

export async function newGrade (educationStageId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/education-stages/' + educationStageId + '/grades', data)
  return response.data.data
}

export async function getGrades (gradeId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + gradeId)
  return response.data.data
}

export async function updateGrade (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + id, data)
  return response.data.data
}

export async function deleteGrade (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + id)
  return response.data.data
}

export default {
  listGrades,
  newGrade,
  getGrades,
  updateGrade,
  deleteGrade
}
